import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C5A56] font-mono-ed text-sm tracking-widest uppercase">
        Verifying session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
